import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useI18n } from "@/i18n";

export default function AuthCallback() {
  const { setUser } = useAuth();
  const { lang, t, errMsg } = useI18n();
  const nav = useNavigate();
  const location = useLocation();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sid = new URLSearchParams(location.hash.slice(1)).get("session_id");
    window.history.replaceState(null, "", window.location.pathname);
    api.post("/auth/google/session", { session_id: sid, lang })
      .then(({ data }) => {
        setUser(data);
        nav("/app", { replace: true });
      })
      .catch((e) => {
        toast.error(errMsg(e));
        nav("/login", { replace: true });
      });
  }, [location.hash, lang, nav, setUser, errMsg]);

  return <div className="min-h-screen grid place-items-center text-neutral-400" data-testid="auth-callback">{t("auth.processing")}</div>;
}
